<template>
    <div>
        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>定时操盘</span>
                <el-button v-if="dataList.length==0" style="float: right; padding: 3px 0" type="text"
                           @click="openStockTradeAtRegularTimeDialog">新增
                </el-button>
            </div>
            <el-table class="turnover-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column fixed prop="pair" label="交易对" width="150"></el-table-column>
                <el-table-column label="开关">
                    <template slot-scope="scope">
                        <el-switch active-color="#13ce66" :value="scope.row.open"
                                   @change="updateStatus(scope.row, $event)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户id" show-overflow-tooltip></el-table-column>
                <el-table-column label="操盘最早时间" width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.executeTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="上涨还是下跌">
                    <template slot-scope="scope">
                        <span>{{scope.row.direction | directionFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操盘类型" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.targetType | targetTypeFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="targetVal" label="交易对目标价格"></el-table-column>
                <el-table-column prop="limitCost" label="是否进行成本限制" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch active-color="#13ce66" :value="scope.row.limitCost" disabled></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="cost" label="最大成本" show-overflow-tooltip width="180"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'用交易币种数量来统计')"></el-table-column>
                <el-table-column prop="minIntervalTime" label="下单最小间隔时间" show-overflow-tooltip width="180"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位秒-由于至少是秒')"></el-table-column>
                <el-table-column prop="maxIntervalTime" label="下单最大间隔时间" show-overflow-tooltip width="180"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位秒-由于至少是秒')"></el-table-column>
                <el-table-column prop="minOrderAmount" label="最小下单量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxOrderAmount" label="最大下单量" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit"
                                   @click="openUpdateStockTradeAtRegularTimeDialog(scope.row)">修改
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="regularTradingData.pair" :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="regularTradingData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">操盘最早时间</span>
                    <el-date-picker v-model="regularTradingData.executeTime" type="datetime" value-format="timestamp"
                                    placeholder="选择操盘最早时间">
                    </el-date-picker>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">上涨还是下跌</span>
                    <el-select v-model="regularTradingData.direction">
                        <el-option label="上涨" value="1"></el-option>
                        <el-option label="下跌" value="-1"></el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">操盘类型</span>
                    <el-select v-model="regularTradingData.targetType">
                        <el-option label="目标价格" value="0"></el-option>
                        <el-option label="上涨下跌百分比" value="1"></el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对目标价格</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="regularTradingData.targetVal"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">是否进行成本限制</span>
                    <el-switch active-color="#13ce66" v-model="regularTradingData.limitCost"></el-switch>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大成本</span>
                    <el-tooltip class="item" effect="dark" content="用交易币种数量来统计" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="regularTradingData.cost"></el-input>
                    </el-tooltip>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单最小间隔时间</span>
                    <el-tooltip class="item" effect="dark" content="单位秒-由于至少是秒" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="regularTradingData.minIntervalTime"></el-input>
                    </el-tooltip>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单最大间隔时间</span>
                    <el-tooltip class="item" effect="dark" content="单位秒-由于至少是秒" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="regularTradingData.maxIntervalTime"></el-input>
                    </el-tooltip>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小下单量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="regularTradingData.minOrderAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大下单量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="regularTradingData.maxOrderAmount"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="createStockTradeAtRegularTime">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'RegularTrading',
        props: {dataList: Array, pair: String},
        data() {
            return {
                loading: false,
                dialogVisible: false,
                dialogTitle: "",
                regularTradingData: { //数据对象
                    pair: "",
                    userId: "",
                    executeTime: "",
                    direction: "",
                    targetType: "",
                    targetVal: "",
                    limitCost: true,
                    cost: "",
                    minIntervalTime: "",
                    maxIntervalTime: "",
                    minOrderAmount: "",
                    maxOrderAmount: "",
                    open: true
                }
            };
        },
        filters: {
            directionFormat(value) {
                let desc = "";
                if (value == 1) {
                    desc = "上涨";
                } else if (value == -1) {
                    desc = "下跌";
                }
                return desc;
            },
            targetTypeFormat(value) {
                let desc = "";
                if (value == 0) {
                    desc = "目标价格";
                } else if (value == 1) {
                    desc = "上涨下跌百分比";
                }
                return desc;
            }
        },
        methods: {
            queryStockTradeAtRegularTimeList() {
                this.$emit('refreshData');
            },
            updateStatus(row, value) {
                api.updateStockTradeStatus({id: row.id, open: value}).then(response => {
                    if (response.code == 0) {
                        this.queryStockTradeAtRegularTimeList();
                    } else {
                        this.$message.success('操作失败');
                    }
                });
            },
            createStockTradeAtRegularTime() {
                if (this.regularTradingData.pair == "") {
                    this.$message.success('请输入交易对!');
                    return
                }
                if (this.regularTradingData.userId == "") {
                    this.$message.success('请输入用户id!');
                    return
                }
                if (this.regularTradingData.executeTime == "") {
                    this.$message.success('请选择操盘最早时间!');
                    return
                }
                if (this.regularTradingData.direction == "") {
                    this.$message.success('请选择上涨还是下跌!');
                    return
                }
                if (this.regularTradingData.targetType == "") {
                    this.$message.success('请选择操盘类型!');
                    return
                }
                if (this.regularTradingData.targetVal == "") {
                    this.$message.success('请输入交易对目标价格!');
                    return
                }
                if (this.regularTradingData.minIntervalTime == "") {
                    this.$message.success('请输入下单最小间隔时间!');
                    return
                }
                if (this.regularTradingData.maxIntervalTime == "") {
                    this.$message.success('请输入下单最大间隔时间!');
                    return
                }
                if (this.regularTradingData.minOrderAmount == "") {
                    this.$message.success('请输入最小下单量!');
                    return
                }
                if (this.regularTradingData.maxOrderAmount == "") {
                    this.$message.success('请输入最大下单量!');
                    return
                }
                this.loading = true;
                api.updateStockTradeAtRegularTimeConfig(this.regularTradingData).then(response => {
                    if (response.code == 0) {
                        this.dialogVisible = false;
                        this.$message.success(this.dialogTitle + '成功');
                        this.queryStockTradeAtRegularTimeList();
                    } else {
                        this.$message.success(this.dialogTitle + '失败');
                    }
                });
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            },
            openStockTradeAtRegularTimeDialog() {
                this.regularTradingData.pair = this.pair;
                this.dialogTitle = "增加";
                this.dialogVisible = true;
            },
            openUpdateStockTradeAtRegularTimeDialog(row) {
                this.regularTradingData = { //数据对象
                    pair: row.pair,
                    userId: row.userId,
                    executeTime: row.executeTime,
                    direction: row.direction + "",
                    targetType: row.targetType + "",
                    targetVal: row.targetVal,
                    limitCost: row.limitCost,
                    cost: row.cost,
                    minIntervalTime: row.minIntervalTime,
                    maxIntervalTime: row.maxIntervalTime,
                    minOrderAmount: row.minOrderAmount,
                    maxOrderAmount: row.maxOrderAmount,
                    open: row.open
                }
                this.dialogTitle = "修改";
                this.dialogVisible = true;
            },
            clearData() {
                this.loading = false;
                this.regularTradingData = { //数据对象
                    pair: this.pair,
                    userId: "",
                    executeTime: "",
                    direction: "",
                    targetType: "",
                    targetVal: "",
                    limitCost: true,
                    cost: "",
                    minIntervalTime: "",
                    maxIntervalTime: "",
                    minOrderAmount: "",
                    maxOrderAmount: "",
                    open: true
                }
            },
            renderTipsHeader(h, {column}, index) {
                return h(
                    'div', [
                        h('span', column.label),
                        h('el-tooltip', {
                            props: {
                                effect: 'dark',
                                content: index,
                                placement: 'top'
                            },
                        }, [
                            h('i', {
                                class: 'el-icon-question',
                                style: 'color:#409EFF;margin-left:5px;'
                            })
                        ])
                    ]
                );
            }
        },
        created() {
            this.regularTradingData.pair = this.pair;
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .turnover-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .turnover-table {
            margin-top: 30px;
        }
    }
</style>
